<template>
    <div class="overlay" @click.self="closeResultWindow">
        <div class="results-window">
            <div class="modal-header">
                <button class="close-btn" @click="closeResultWindow">×</button>
            </div>
            
            <div class="modal-content">
                <div class="score-title">
                    <div v-if="score == 0">
                        <h2>{{ score }}番就唔好學人計番啦</h2>
                    </div>
                    <div v-else-if="score > 100">
                        <h2>真係犀鳩利！總共食左{{ score }}番！</h2>
                    </div>
                    <div v-else>
                        <h2>恭喜你！總共食左{{ score }}番！</h2>
                    </div>
                </div>

                <div class="options-list-container">
                    <v-list density="compact" class="transparent-list">
                        <v-list-item v-for="option in options" :key="option.name" class="result-item">
                            <div class="result-item-content">
                                <span class="item-name">{{ option.name }}</span>
                                <span class="item-dots"></span>
                                <span class="item-value">{{ option.value*option.quantity }}番</span>
                            </div>
                        </v-list-item>
                    </v-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                options: this.selectedOptions
            }
        },
        props:{
            score: Number,
            selectedOptions: Array,
        },

        methods: {
            closeResultWindow() {
                this.$emit('close');
            }
        }
    }
</script>

<style scoped>
    .overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
        backdrop-filter: blur(4px);
        z-index: 2100;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: calc(20px + env(safe-area-inset-top)) calc(20px + env(safe-area-inset-right)) calc(20px + env(safe-area-inset-bottom)) calc(20px + env(safe-area-inset-left));
    }

    .results-window {
        background-color: white;
        width: 95%;
        max-width: 450px;
        max-height: 85vh;
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
        border-radius: 24px;
        display: flex;
        flex-direction: column;
        animation: slideUp 0.3s ease-out;
        overflow: hidden;
    }

    @keyframes slideUp {
        from { transform: translateY(20px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
    }

    .modal-header {
        display: flex;
        justify-content: flex-end;
        padding: 12px 15px 0;
    }

    .modal-content {
        padding: 0 25px 30px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .score-title h2 {
        margin-bottom: 20px;
        font-size: 22px;
        color: #2c3e50;
        line-height: 1.4;
        text-align: center;
    }

    .options-list-container {
        overflow-y: auto;
        margin-top: 5px;
        padding-right: 5px;
    }

    .transparent-list {
        background: transparent !important;
    }

    .result-item-content {
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 15px;
        color: #333;
    }

    .item-name {
        font-weight: 500;
    }

    .item-dots {
        flex: 1;
        border-bottom: 1px dotted #ccc;
        margin: 0 10px;
        height: 14px;
    }

    .item-value {
        color: #4CAF50;
        font-weight: bold;
    }

    /* Custom scrollbar */
    .options-list-container::-webkit-scrollbar {
        width: 5px;
    }
    .options-list-container::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }
    .options-list-container::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 10px;
    }

    .close-btn {
        font-size: 24px;
        border: none;
        background: #f8f9fa;
        color: #999;
        cursor: pointer;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
    }

    .close-btn:hover {
        background: #eee;
        color: #666;
        transform: rotate(90deg);
    }
</style>